import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "@/api/client";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Request failed");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="space-y-4 text-center">
        <p className="text-sm text-ink-2">
          If an account exists for <span className="font-medium text-ink">{email}</span>,
          you'll receive a reset link shortly.
        </p>
        <Link to="/login" className="text-sm text-ink-3 transition-colors hover:text-ink">
          Back to login
        </Link>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <p className="text-sm text-ink-3">
        Enter your email and we'll send you a link to reset your password.
      </p>
      <div className="space-y-2">
        <label className="text-sm font-medium text-ink-2">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input px-3.5 py-2.5 text-sm"
          placeholder="you@example.com"
        />
      </div>
      {error && <p className="text-sm text-bad">{error}</p>}
      <button
        type="submit"
        disabled={loading}
        className="btn btn--accent w-full px-3.5 py-2.5 text-sm shadow-sm"
      >
        {loading ? "Sending..." : "Send reset link"}
      </button>
      <p className="text-center text-sm text-ink-3">
        <Link to="/login" className="text-ink-2 transition-colors hover:text-ink">
          Back to login
        </Link>
      </p>
    </form>
  );
}
